import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-row',
  templateUrl: './empty-row.component.html',
  styleUrls: ['./empty-row.component.scss']
})
export class EmptyRowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
